module.exports = __webpack_public_path__ + "static/media/iphone_14_red.1f4ead73.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_14_red.jpeg
// module id = 2129
// module chunks = 0